/*eslint-disable*/
import * as React from "react";
import { DrillDownButton } from "../Buttons";
import { Button as MuiButton, SvgIcon, Chip  } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import LeakAddRoundedIcon from "@material-ui/icons/LeakAddRounded";
import TodayIcon from "@material-ui/icons/Today";
import DeleteIcon from "@material-ui/icons/Delete";
// import Blur from "../Blur";
import PublishIcon from "@material-ui/icons/Publish";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTranslation } from "react-i18next";


const useStyles = makeStyles(theme => ({
  cell: {
    maxWidth: 300,
    whiteSpace: "normal",
    // padding: 5,
    paddingBottom: 5,
    paddingTop: 5,
    minHeight: 55,
    minWidth: 120,
    wordWrap: "break-word"
  },
  smallcell: {
    maxWidth: 300,
    whiteSpace: "normal",
    // padding: 5,
    paddingBottom: 5,
    paddingTop: 5,
    minHeight: 55,
    minWidth: 171,
    wordWrap: "break-word"
  },
  mediumcell: {
    maxWidth: 300,
    whiteSpace: "normal",
    paddingBottom: 5,
    paddingTop: 5,
    minHeight: 55,
    minWidth: 236,
    wordWrap: "break-word"
  },
  row: {
    paddingTop: 5,
    paddingBottom: 5,
    height: 55
  },
  buittonPadding:{
    color: "#2D9F86",
    fontWeight:"700",
    fontSize:"14px",
    letterSpacing:"0.75px",
    textTransform: "uppercase !important"
  }
}));

const style = {
  width: "30px",
  height: "30px"
};

const StyledTableRow = withStyles({
  root: {
    paddingTop: 5,
    paddingBottom: 5,
    height: 55,
    '&:nth-of-type(even)': {
      backgroundColor: props => props.isflipshadow === "true"  ?  "#FAFAFA" : "#FFFFFF",
    },
  },
})(TableRow);

function useWidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || "xs"
  );
}


const ListRow = props => {
  const { t } = useTranslation();
  const mediawidth = useWidth();  
  const {
    indexvalue,
    entityValues,
    // feature,
    viewFeedbackDetailsAction,
    viewAdminConsultationDetailsAction,
    editAction,
    mergeAction,
    calendarAction,
    clinicalSummaryAction,
    pthreesixtyAction,
    fhiraction,
    deleteAction,
    // toggleChecked,
    // onToggleChange,
    drillDownAction,
    uploadlabresultssAction,
    uploadappointmentsAction,
    isLoading,
    padded
  } = props;

  const classes = useStyles();
  let statuses =
    entityValues &&
    entityValues.filter(
      (value) =>
        value === "Completed" ||
        value === "Pending" ||
        value === "Scheduled" ||
        value === "Closed" ||
        value === "Canceled" ||
        value === "Missed" ||
        value === "In progress" ||
        value === "Doctor review started" ||        
        value === "Report being generated" ||
        value === "Report Generation" ||
        value === "Declined" ||
        value === "Patient Canceled" ||
        value === "Doctor Canceled" ||
        value === "System Canceled" ||
        value === "Admin Canceled" ||
        value === "Patient Canceled" ||
        value === "Tech issues - patient" ||
        value === "Tech issues - doctor" ||
        value === "Doctor disconnected" ||
        value === "Doctor Missed" ||
        value === "Patient Missed"
    );
      


        
  let cellClass = "";
  if (statuses.includes("Completed")) {
    cellClass += " status_green_completed";
  } else if (statuses.includes("Pending")) {
    cellClass += " status_purple";
  } else if (statuses.includes("Scheduled")) {
    cellClass += " status_green_scheduled";
  } else if (
    statuses.includes("Canceled") ||
    statuses.includes("Missed") ||
    statuses.includes("Declined")
  ) {
    cellClass += " status_red_canceled";
  } else if (
    statuses.includes("Report being generated") ||
    statuses.includes("Report Generation")
  ) {
    cellClass += " status_gray_reportgenerated";
  } else if (statuses.includes("In progress")) {
    cellClass += " status_gray_inprogress";
  } else if (statuses.includes("Doctor review started")) {
    cellClass += " status_gray_doctorreviewstarted";
  } else if (
    statuses.includes("Patient Canceled") ||
    statuses.includes("Doctor Canceled") ||
    statuses.includes("System Canceled") ||
    statuses.includes("Admin Canceled")
  ) {
    cellClass += " status_red_canceled";
  } else if (
    statuses.includes("Tech issues - patient") ||
    statuses.includes("Tech issues - doctor") ||
    statuses.includes("Doctor disconnected") ||
    statuses.includes("Closed") ||
    statuses.includes("Patient Missed") ||
    statuses.includes("Doctor Missed")
  ) {
    cellClass += " status_orange_closed";
  }
  // else if (statuses.includes("Patient Canceled")) {
  //   cellClass += " status_red_canceled";
  // }
  else {
    cellClass += " status_purple";
  }

  

  return (
    <StyledTableRow
      key={indexvalue}
      isflipshadow={
        !!viewAdminConsultationDetailsAction === false ? "false" : "true"
      }
    >
      {entityValues &&
        entityValues
          .filter((x) => typeof x !== "boolean")
          .filter(
            (a) =>
              a !== "appointmentStatusId10" &&
              a !== "closedReasonType1" &&
              a !== "closedReasonTypenull" &&
              a !== "appointmentStatusIdnull" &&
              a !== "closedReasonType" &&
              a !== "appointmentStatusId" &&
              a !== "closedReasonType" &&
              a !== "appointmentStatusId4" &&
              a !== "closedReasonType2" &&
              a !== "closedReasonType2" &&
              a !== "appointmentStatusId7" &&
              a !== "appointmentStatusId3" &&
              a !== "appointmentStatusId2" &&
              a !== "appointmentStatusId1" &&
              a !== "appointmentStatusId5" &&
              a !== "closedReasonType3" &&
              a !== "closedReasonType4" &&
              a !== "closedReasonType5" &&
              a !== "appointmentStatusId11"
          )
          .map((value, index) =>
            value === "Completed" ||
            value === "Pending" ||
            value === "Scheduled" ||
            value === "Closed" ||
            value === "Canceled" ||
            value === "Missed" ||
            value === "Report being generated" ||
            value === "In progress" ||
            value === "Doctor review started" ||
            value === "Declined" ||
            value === "Patient Canceled" ||
            value === "Doctor Canceled" ||
            value === "System Canceled" ||
            value === "Admin Canceled" ||
            value === "Patient Missed" ||
            value === "Doctor Missed" ||
            value === "Tech issues - patient" ||
            value === "Tech issues - doctor" ||
            value === "Report Generation"
            
            ? (
              <TableCell
                className={classes.cell}
                key={index}
                padded={padded ? "padded" : null}
                size="medium"
              >
                <Chip size="small" className={cellClass} label={value} />
              </TableCell>
            ) : (
              <TableCell
                className={
                  mediawidth === "xs"
                    ? classes.cell
                    : (mediawidth === "md" || mediawidth === "sm") &&
                      !!viewAdminConsultationDetailsAction === true &&
                      (value.toString().includes("AM") ||
                        value.toString().includes("PM"))
                    ? classes.smallcell
                    : (mediawidth === "md" || mediawidth === "sm") &&
                      !!viewFeedbackDetailsAction === true &&
                      (value.toString().includes("AM") ||
                        value.toString().includes("PM"))
                    ? classes.mediumcell
                    : classes.cell
                }
                // classes={{
                //   root: classes.cell,
                // }}
                key={index}
                padded={padded ? "padded" : null}
                size="medium"
              >
                {value}
              </TableCell>
            )
          )}

      {!!clinicalSummaryAction && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="small"
            // variant="outlined"
            color="primary"
            className={classes.buittonPadding}
            onClick={() => clinicalSummaryAction()}
          >
            <SvgIcon style={style} color="#ffff" viewBox="0 0 32 32">
              <path d="M31.829 4.845c0-0.414-0.336-0.75-0.75-0.75v0h-3.338c-0.351-1.444-1.633-2.5-3.162-2.5s-2.811 1.056-3.157 2.478l-0.005 0.022h-1.177c-0.351-1.444-1.633-2.5-3.162-2.5s-2.811 1.056-3.157 2.478l-0.005 0.022h-1.177c-0.351-1.444-1.633-2.5-3.162-2.5s-2.811 1.056-3.157 2.478l-0.005 0.022h-1.339c-0.351 0.002-0.645 0.243-0.728 0.568l-0.001 0.005-4 16.5c-0.013 0.053-0.021 0.114-0.021 0.177 0 0.414 0.336 0.75 0.75 0.75h3.25v2.75c0 0.414 0.336 0.75 0.75 0.75v0h13.276c0.39 3.391 3.244 6 6.708 6 3.67 0 6.656-2.929 6.748-6.578l0-0.009c-0-0.079 0.018-20.164 0.018-20.164zM30.329 20.628c-0.302-0.374-0.63-0.705-0.988-1l-0.012-0.009v-4.773c0-0.414-0.336-0.75-0.75-0.75s-0.75 0.336-0.75 0.75v0 3.843c-0.495-0.23-1.070-0.408-1.672-0.505l-0.038-0.005 3.051-12.583h1.16zM5.669 5.595h0.748c0.353 1.443 1.634 2.498 3.161 2.5h0c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0c-0.694-0.001-1.293-0.404-1.576-0.99l-0.005-0.010h5.919c0.353 1.443 1.634 2.498 3.161 2.5h0c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0c-0.694-0.001-1.293-0.404-1.576-0.99l-0.005-0.010h5.919c0.353 1.443 1.634 2.498 3.161 2.5h0c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0c-0.694-0.001-1.293-0.404-1.576-0.99l-0.005-0.010h4.627l-0.849 3.5h-21.956zM24.579 3.095c0.694 0.001 1.293 0.404 1.576 0.99l0.005 0.010h-3.161c0.288-0.596 0.887-0.999 1.581-1h0zM17.079 3.095c0.694 0.001 1.293 0.404 1.576 0.99l0.005 0.010h-3.161c0.288-0.596 0.887-0.999 1.581-1h0zM9.579 3.095c0.694 0.001 1.293 0.404 1.576 0.99l0.005 0.010h-3.161c0.288-0.596 0.887-0.999 1.581-1h0zM4.456 10.595h21.956l-1.822 7.517c-1.931 0.14-3.619 1.073-4.758 2.471l-0.010 0.012h-17.79zM5.829 22.095h13.070c-0.268 0.583-0.46 1.259-0.541 1.969l-0.003 0.031h-12.526zM25.813 30.041v-0.696c0-0.414-0.336-0.75-0.75-0.75s-0.75 0.336-0.75 0.75v0 0.696c-2.303-0.346-4.1-2.143-4.442-4.417l-0.004-0.029h0.696c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-0.696c0.346-2.303 2.143-4.1 4.417-4.442l0.029-0.004v0.695c0 0.414 0.336 0.75 0.75 0.75s0.75-0.336 0.75-0.75v0-0.695c2.303 0.346 4.1 2.143 4.442 4.417l0.004 0.029h-0.696c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h0.696c-0.346 2.303-2.143 4.1-4.417 4.442l-0.029 0.004z"></path>
              <path d="M16.329 13.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M11.329 13.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M6.329 13.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M21.329 13.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M15.329 16.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M10.329 16.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M5.329 16.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M20.329 16.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M14.829 19.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M9.829 19.345h2c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0z"></path>
              <path d="M7.579 18.595c0-0.414-0.336-0.75-0.75-0.75v0h-2c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h2c0.414 0 0.75-0.336 0.75-0.75v0z"></path>
              <path d="M26.532 22.315l-1.618 1.618-1.517-0.758c-0.098-0.050-0.213-0.079-0.335-0.079-0.414 0-0.75 0.336-0.75 0.75 0 0.292 0.167 0.545 0.41 0.669l0.004 0.002 2 1c0.098 0.050 0.213 0.079 0.335 0.079 0.207 0 0.395-0.084 0.53-0.22l2-2c0.135-0.136 0.218-0.323 0.218-0.529 0-0.414-0.336-0.75-0.75-0.75-0.206 0-0.393 0.083-0.529 0.218l0-0z"></path>
            </SvgIcon>
          </MuiButton>
        </TableCell>
      )}

      {!!pthreesixtyAction && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="small"
            // variant="outlined"
            // color="primary"
            className={classes.p360button}
            onClick={() => pthreesixtyAction()}
          >
            <SvgIcon style={style} color="#ffff" viewBox="0 0 32 32">
              <path
                // fill="#00efd1"
                // fill="#615e5e"
                d="M12.84 14.368c1.036 0.064 2.11 0.098 3.211 0.098 1.123 0 2.218-0.035 3.274-0.102 0.9-0.056 1.77-0.136 2.604-0.236 0.634-0.076 1.248-0.165 1.836-0.265 4.469-0.755 7.519-2.144 7.701-3.748l0.009 0.001-0.099 11.309c0 1.399-2.169 2.649-5.583 3.475h-0.001l-6.998-5.413-3.726 3.535-4.874-3.445-5.243 4.977-0.005 0.018c-2.731-0.812-4.419-1.924-4.419-3.149l0.101-11.462c0 1.641 3.005 3.076 7.496 3.863 0.674 0.118 1.379 0.222 2.116 0.31 0.833 0.099 1.703 0.177 2.601 0.233zM16.015 17.824c-0-0.831-0.674-1.505-1.506-1.505s-1.505 0.674-1.505 1.505 0.674 1.505 1.505 1.505c0.832 0 1.506-0.674 1.506-1.506z"
              ></path>
              <path
                // fill="#00acea"
                // fill="#615e5e"
                d="M31.474 9.963c0 0.051-0.003 0.102-0.009 0.152-0.182 1.603-3.232 2.993-7.701 3.748l-0.010-7.803c4.615 0.778 7.72 2.235 7.72 3.903z"
              ></path>
              <path
                // fill="#87e680"
                // fill="#000000"
                d="M13.151 25.852c-0.332-0.018-0.66-0.039-0.984-0.063l0.001-0.014 6.625-6.287 6.998 5.413c-1.916 0.464-4.225 0.794-6.763 0.942-0.95 0.055-1.933 0.085-2.939 0.087h-0.089c-0.974 0-1.927-0.026-2.851-0.077z"
              ></path>
              <path
                // fill="#fedb41"
                // fill="#000000"
                d="M19.324 14.364c-1.055 0.067-2.15 0.102-3.274 0.102-1.101 0-2.175-0.033-3.211-0.098-0.898-0.055-1.768-0.133-2.601-0.233v-3.891c-0.008-0.082-0.013-0.165-0.013-0.247 0-1.353 1.097-2.45 2.45-2.45h1.318l2.089 2.033 2.166-2.033h1.242c0.082 0 0.164 0.005 0.246 0.013 1.346 0.136 2.327 1.338 2.191 2.685v3.883c-0.834 0.101-1.704 0.18-2.604 0.236z"
              ></path>
              <path
                // fill="#fedb41"
                // fill="#000000"
                d="M19.029 25.842v0.003l-0.12 4.022c-0.028 0.769-0.666 1.373-1.435 1.359s-1.385-0.641-1.385-1.41v-3.888c1.006-0.002 1.989-0.032 2.939-0.087z"
              ></path>
              <path
                // fill="#fedb41"
                // fill="#000000"
                d="M18.359 3.213v0.944c0 1.303-1.056 2.359-2.359 2.359s-2.358-1.056-2.358-2.359v-0.944c0-1.303 1.056-2.359 2.358-2.359s2.359 1.056 2.359 2.359z"
              ></path>
              <path
                // fill="#fedb41"
                // fill="#000000"
                // style="fill: var(--color4, #fedb41)"
                d="M16.090 25.929v3.888c0 0.769-0.616 1.396-1.385 1.41s-1.407-0.59-1.435-1.359l-0.12-4.016c0.924 0.051 1.877 0.077 2.851 0.077z"
              ></path>
              <path
                // fill="#fedb41"
                // fill="#000000"
                d="M14.509 16.319c0.831-0 1.505 0.674 1.506 1.505s-0.674 1.505-1.506 1.505c-0.831 0-1.505-0.674-1.505-1.506s0.674-1.505 1.505-1.505z"
              ></path>
              <path
                // fill="#3bb54a"
                d="M15.068 23.023l-2.9 2.752-0.001 0.014c-2.783-0.208-5.269-0.635-7.222-1.215l0.005-0.018 5.243-4.977z"
              ></path>
              <path
                // fill="#00acea"
                d="M8.135 6.097l-0.011 7.722-0.001 0.007c-4.491-0.787-7.496-2.222-7.496-3.863 0-1.642 3.010-3.079 7.508-3.866z"
              ></path>
              <path
                // fill="#083863"
                fill="#000000"
                d="M23.841 5.542c-0.153-0.026-0.309 0.017-0.427 0.117s-0.186 0.247-0.186 0.402l0.008 7.355c-0.257 0.040-0.523 0.078-0.786 0.114v-3.26c0.071-0.776-0.164-1.549-0.655-2.153-0.499-0.612-1.222-0.998-2.008-1.072-0.104-0.010-0.2-0.007-0.296-0.007h-1.242c-0.133-0.003-0.262 0.045-0.36 0.135l-1.799 1.685-1.73-1.676c-0.099-0.094-0.23-0.146-0.366-0.144h-1.318c-1.643-0.002-2.977 1.326-2.983 2.968 0 0.092 0.006 0.177 0.006 0.265v3.268c-0.329-0.048-0.708-0.1-1.055-0.157l0.013-7.284c0.001-0.155-0.067-0.303-0.186-0.403-0.117-0.104-0.273-0.151-0.428-0.13-5.043 0.882-7.937 2.524-7.942 4.364l-0.101 11.482c0 1.457 1.658 2.727 4.795 3.66 2.023 0.601 4.559 1.032 7.332 1.239 0.169 0.013 0.34 0.026 0.512 0.037l0.106 3.539c0.028 0.781 0.522 1.468 1.254 1.743s1.556 0.082 2.091-0.488c0.014 0.014 0.027 0.029 0.041 0.043 0.545 0.546 1.362 0.716 2.079 0.433s1.199-0.964 1.226-1.734l0.106-3.547c2.283-0.156 4.437-0.465 6.267-0.9 0.083 0 0.164-0.020 0.238-0.057 2.247-0.557 5.857-1.788 5.857-3.95l0.099-11.309h-0.008c0.005-0.051 0.008-0.102 0.008-0.158 0-2.749-5.706-4.008-8.159-4.421zM30.948 9.963c0 0.028-0.002 0.057-0.005 0.085-0 0.003-0.001 0.006-0.001 0.008-0.066 0.577-0.757 1.208-1.947 1.777-1.175 0.562-2.793 1.043-4.706 1.403l-0.009-6.548c4.6 0.86 6.668 2.246 6.668 3.275zM12.676 8.089h1.104l1.936 1.876c0.001 0.001 0.002-0.002 0.003-0.001 0.012 0.011 0.023 0.020 0.036 0.030 0.001 0.001 0.002 0.001 0.003 0.002 0.013 0.010 0.026 0.020 0.040 0.028 0.001 0.001 0.001 0.001 0.002 0.001 0.014 0.009 0.029 0.017 0.043 0.025 0 0 0.001-0.005 0.001-0.004 0.014 0.009 0.030 0.014 0.046 0.016 0.142 0.063 0.306 0.054 0.441-0.023 0.001 0 0.001 0.002 0.002 0.001 0.014-0.008 0.028-0.015 0.041-0.024 0.002-0.001 0.003-0.001 0.004-0.002 0.013-0.009 0.025-0.018 0.037-0.028 0.002-0.001 0.004-0.003 0.005-0.004 0.006-0.006 0.013-0.003 0.020-0.009l2.014-1.883h1.034c0.062 0 0.126-0.004 0.194 0.002 0.507 0.049 0.974 0.299 1.297 0.694s0.474 0.902 0.422 1.409c-0.003 0.017-0.004 0.034-0.005 0.051v3.413c-0.526 0.055-1.052 0.103-1.577 0.143v-1.159c0-0.29-0.235-0.526-0.526-0.526s-0.526 0.235-0.526 0.526v1.225c-1.795 0.094-3.594 0.095-5.389 0.003v-1.228c0-0.29-0.235-0.526-0.526-0.526s-0.526 0.235-0.526 0.526v1.163c-0.526-0.039-1.052-0.085-1.577-0.14v-3.42c0.002-0.018 0.004-0.036 0.004-0.054-0.005-0.062-0.008-0.123-0.007-0.185 0.004-1.062 0.866-1.92 1.928-1.917zM7.608 6.729l-0.009 6.466c-4.447-0.864-6.446-2.228-6.446-3.232 0-1.005 2.002-2.37 6.455-3.234zM18.998 25.303c-0.947 0.055-1.926 0.071-2.909 0.071h-0.089c-0.877 0-1.752-0.008-2.608-0.051l5.436-5.151 5.753 4.446c-1.678 0.336-3.584 0.568-5.583 0.685zM11.962 25.245c-2.216-0.177-4.262-0.497-5.99-0.935l4.27-4.053 3.999 2.826zM14.672 30.701c-0.473-0.001-0.861-0.376-0.878-0.849l-0.109-3.448c0.617 0.027 1.273 0.042 1.864 0.047v3.365c0.001 0.234-0.090 0.458-0.255 0.624s-0.388 0.259-0.622 0.26zM17.5 30.701c-0.491 0.001-0.892-0.393-0.899-0.884v-3.367c0.657-0.007 1.263-0.025 1.878-0.054l-0.099 3.453c-0.014 0.476-0.405 0.854-0.881 0.852zM25.912 24.329l-6.797-5.257c-0.205-0.159-0.495-0.144-0.683 0.034l-3.413 3.238-4.522-3.196c-0.205-0.145-0.483-0.125-0.665 0.048l-5.037 4.781c-2.351-0.74-3.744-1.686-3.744-2.548l0.085-9.597c1.257 1.063 3.623 1.938 6.896 2.511 0.656 0.115 1.342 0.216 2.040 0.301 0.054 0.018 0.11 0.027 0.166 0.027 0.015 0 0.030-0.001 0.045-0.002 0.781 0.091 1.592 0.164 2.416 0.216 0.046 0.013 0.093 0.020 0.141 0.020 0.026-0 0.052-0.002 0.077-0.006 1.022 0.061 2.075 0.093 3.133 0.093 1.073 0 2.14-0.033 3.175-0.095 0.087 0.017 0.177 0.011 0.261-0.016 0.842-0.055 1.672-0.131 2.469-0.226 0.027-0.001 0.053-0.004 0.079-0.009 0.622-0.075 1.233-0.164 1.817-0.263 1.765-0.298 5.306-1.052 7.081-2.515l-0.083 9.559c0 0.809-1.304 1.987-4.938 2.904z"
              ></path>
              <path
                // fill="#083863"
                fill="#000000"
                d="M16.008 7.041c1.594-0.001 2.887-1.29 2.892-2.884v-0.944c0-1.597-1.295-2.892-2.892-2.892s-2.892 1.295-2.892 2.892v0.944c0.004 1.594 1.297 2.884 2.891 2.884zM14.168 3.213c0-1.016 0.824-1.84 1.84-1.84s1.84 0.824 1.84 1.84v0.944c0 1.016-0.824 1.84-1.84 1.84s-1.84-0.824-1.84-1.84z"
              ></path>
              <path
                // fill="#000000"
                d="M14.509 15.793c-1.122 0-2.031 0.91-2.031 2.032s0.91 2.031 2.032 2.031c1.122 0 2.031-0.91 2.031-2.032-0.001-1.121-0.91-2.030-2.032-2.031zM14.509 18.804c-0.541 0-0.979-0.439-0.979-0.98s0.438-0.979 0.979-0.979 0.98 0.438 0.98 0.979c-0.001 0.541-0.439 0.98-0.98 0.98z"
              ></path>
            </SvgIcon>
          </MuiButton>
        </TableCell>
      )}

      {!!fhiraction && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="medium"
            // variant="outlined"
            color="primary"
            className={classes.buittonPadding}
            onClick={() => fhiraction()}
          >
            <SvgIcon style={style} color="#ffff" viewBox="0 0 32 32">
              <path
                // fill="#00efd1"
                d="M17.55,11.2C17.32,10.9 17.05,10.64 16.79,10.38C16.14,9.78 15.39,9.35 14.76,8.72C13.3,7.26 13,4.85 13.91,3C13,3.23 12.16,3.75 11.46,4.32C8.92,6.4 7.92,10.07 9.12,13.22C9.16,13.32 9.2,13.42 9.2,13.55C9.2,13.77 9.05,13.97 8.85,14.05C8.63,14.15 8.39,14.09 8.21,13.93C8.15,13.88 8.11,13.83 8.06,13.76C6.96,12.33 6.78,10.28 7.53,8.64C5.89,10 5,12.3 5.14,14.47C5.18,14.97 5.24,15.47 5.41,15.97C5.55,16.57 5.81,17.17 6.13,17.7C7.17,19.43 9,20.67 10.97,20.92C13.07,21.19 15.32,20.8 16.93,19.32C18.73,17.66 19.38,15 18.43,12.72L18.3,12.46C18.1,12 17.83,11.59 17.5,11.21L17.55,11.2M14.45,17.5C14.17,17.74 13.72,18 13.37,18.1C12.27,18.5 11.17,17.94 10.5,17.28C11.69,17 12.39,16.12 12.59,15.23C12.76,14.43 12.45,13.77 12.32,13C12.2,12.26 12.22,11.63 12.5,10.94C12.67,11.32 12.87,11.7 13.1,12C13.86,13 15.05,13.44 15.3,14.8C15.34,14.94 15.36,15.08 15.36,15.23C15.39,16.05 15.04,16.95 14.44,17.5H14.45Z"
              ></path>
            </SvgIcon>
          </MuiButton>
        </TableCell>
      )}

      {!!mergeAction && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="small"
            variant="outlined"
            color="primary"
            className={classes.buittonPadding}
            onClick={() => mergeAction()}
          >
            <LeakAddRoundedIcon />
          </MuiButton>
        </TableCell>
      )}

      {/* {typeof toggleChecked === "boolean" && !!onToggleChange && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
        
            <Switch
              checked={toggleChecked}
              onChange={
                () =>
                  !isLoading
                    ? onToggleChange()
                    : alert("You are not allowed to enable this record") //NOSONAR
              }
              value="checkedA"
              inputProps={{
                "aria-label": "secondary checkbox"
              }}
              color="primary"
            />
        </TableCell>
      )} */}

      {!!calendarAction && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="small"
            color="primary"
            className={classes.buittonPadding}
            onClick={() => calendarAction()}
          >
            <TodayIcon />
          </MuiButton>
        </TableCell>
      )}

      {!!editAction === true &&
        entityValues.filter((x) => typeof x === "boolean")[0] &&
        entityValues.filter((x) => x === "Completed" || x === "Closed").length >
          0 && (
          <TableCell
            className={
              mediawidth === "xs"
                ? classes.searchbarroot
                : mediawidth === "sm"
                ? classes.smallcell
                : classes.cell
            }
            padded={padded ? "padded" : null}
            size="medium"
          >
            <MuiButton
              size="small"
              color="primary"
              disabled={
                entityValues.filter((x) => x === "appointmentStatusId10")
                  .length > 0 &&
                entityValues.filter((x) => x === "closedReasonType1").length > 0
              }
              className={classes.buittonPadding}
              onClick={() => editAction()}
            >
              {/* <EditIcon /> */}
              View Report
            </MuiButton>
          </TableCell>
        )}

      {!!editAction === true &&
        entityValues.filter((x) => typeof x === "boolean")[0] === false && (
          <TableCell
            className={
              mediawidth === "xs"
                ? classes.searchbarroot
                : mediawidth === "sm"
                ? classes.smallcell
                : classes.cell
            }
            padded={padded ? "padded" : null}
            size="medium"
          >
            <MuiButton
              size="small"
              color="primary"
              className={classes.buittonPadding}
              onClick={() => editAction()}
            >
              {/* <EditIcon /> */}
              {t("View Details")}
            </MuiButton>
          </TableCell>
        )}

      {/* {!!editAction === true && entityValues.filter(x => typeof x === "boolean")[0] === false && entityValues.filter(x => x === "Scheduled").length <= 0 && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >      
           
        </TableCell>
      )} */}

      {!!viewFeedbackDetailsAction === true &&
        entityValues.filter((x) => typeof x === "boolean")[0] && (
          <TableCell
            className={
              mediawidth === "xs"
                ? classes.cell
                : mediawidth === "sm"
                ? classes.smallcell
                : classes.cell
            }
            padded={padded ? "padded" : null}
            size="medium"
          >
            <MuiButton
              size="small"
              color="primary"
              className={classes.buittonPadding}
              onClick={() => viewFeedbackDetailsAction()}
            >
              {t("View Details")}
            </MuiButton>
          </TableCell>
        )}

      {!!viewFeedbackDetailsAction === true &&
        !entityValues.filter((x) => typeof x === "boolean")[0] && (
          <TableCell
            className={classes.cell}
            padded={padded ? "padded" : null}
            size="medium"
          ></TableCell>
        )}

      {!!viewAdminConsultationDetailsAction === true && (
        <TableCell
          className={
            mediawidth === "xs"
              ? classes.searchbarroot
              : mediawidth === "sm"
              ? classes.smallcell
              : classes.cell
          }
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="small"
            color="primary"
            className={classes.buittonPadding}
            onClick={() => viewAdminConsultationDetailsAction()}
          >
            {t("View Details")}
          </MuiButton>
        </TableCell>
      )}

      {!!deleteAction && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="small"
            className={classes.errorbutton}
            onClick={
              () =>
                !isLoading
                  ? deleteAction()
                  : window.alert(
                      "You are not allowed to delete this record while data is updating"
                    ) // NOSONAR Alert UI
            }
          >
            <DeleteIcon />
          </MuiButton>
        </TableCell>
      )}

      {!!uploadappointmentsAction && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="small"
            color="primary"
            className={classes.buittonPadding}
            onClick={() => uploadappointmentsAction()}
          >
            <PublishIcon />
          </MuiButton>
        </TableCell>
      )}

      {!!uploadlabresultssAction && (
        <TableCell
          className={classes.cell}
          padded={padded ? "padded" : null}
          size="medium"
        >
          <MuiButton
            size="small"
            color="primary"
            className={classes.buittonPadding}
            onClick={() => uploadlabresultssAction()}
          >
            <PublishIcon />
          </MuiButton>
        </TableCell>
      )}

      {drillDownAction && (
        <td style={{ border: 0, padding: 0 }}>
          <DrillDownButton type="button" onClick={() => drillDownAction()} />
        </td>
      )}
    </StyledTableRow>
  );
};

export default ListRow;
